var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1113 0.408311C11.1113 0.18286 10.9283 0 10.703 0H6.85653C6.63108 0 6.44822 0.183009 6.44822 0.408311V1.0049H0V2.43407H6.44822V3.03066C6.44822 3.25611 6.63123 3.43897 6.85653 3.43897L10.703 3.43911C10.9285 3.43911 11.1113 3.2561 11.1113 3.0308V2.43422H17.5592V1.00504L11.1113 1.0049V0.408311ZM14.9906 7.05633C14.9906 6.83088 14.8076 6.64802 14.5823 6.64802H10.5316C10.3062 6.64802 10.1233 6.83103 10.1233 7.05633V7.65292H0V9.0821H10.123V9.67868C10.123 9.90413 10.306 10.087 10.5313 10.087H14.5819C14.8074 10.087 14.9902 9.90398 14.9902 9.67868V9.0821H17.5588V7.65292H14.9902L14.9906 7.05633Z",
    fill: "#43927C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.95be541adb59daa764bf93c0851a6332.svg";
export { ForwardRef as ReactComponent };